import { useEffect, useState } from 'react';
import { getApprovalConfig, updateApprovalConfig } from '../../api/constlink';
import ApprovalLineListComponent from '../../components/enterprises/ApprovalLineListComponent';
import ApprovalLineAddModal from '../../components/enterprises/ApprovalLineAddModal';

interface ApprovalConfigContainerProps {
  enterpriseId: string;
}

function ApprovalConfigContainer({
  enterpriseId,
}: ApprovalConfigContainerProps) {
  const [visibleApprovalLineAddModal, setVisibleApprovalLineAddModal] =
    useState(false);
  const [approvalConfig, setApprovalConfig] = useState<any>();

  useEffect(() => {
    (async () => {
      const _approvalConfig = await getApprovalConfig({ enterpriseId });
      setApprovalConfig(_approvalConfig);
    })();
  }, [enterpriseId]);

  const onDeleteApprovalLine = async (name: string) => {
    const filteredApprovalLines = approvalConfig.approvalLines.filter(
      (approvalLine: any) => approvalLine.name !== name,
    );
    const resApprovalConfig = await updateApprovalConfig({
      enterpriseId,
      data: { ...approvalConfig, approvalLines: filteredApprovalLines },
    });
    setApprovalConfig(resApprovalConfig);
  };

  const onCreateApprovalLine = async (approvalLine: any) => {
    if (approvalLine.referers === undefined) {
      approvalLine.referers = [];
    }
    const _approvalLines = [...approvalConfig.approvalLines];
    _approvalLines.push(approvalLine);
    const resApprovalConfig = await updateApprovalConfig({
      enterpriseId,
      data: { ...approvalConfig, approvalLines: _approvalLines },
    });
    setApprovalConfig(resApprovalConfig);
    setVisibleApprovalLineAddModal(false);
  };

  const closeApprovalLineAddModal = () => {
    setVisibleApprovalLineAddModal(false);
  };

  const openApprovalLineAddModal = () => setVisibleApprovalLineAddModal(true);

  return (
    <>
      {approvalConfig && (
        <ApprovalLineListComponent
          types={approvalConfig.approvalLines}
          onDelete={onDeleteApprovalLine}
          openApprovalLineAddModal={openApprovalLineAddModal}
        />
      )}

      {visibleApprovalLineAddModal && approvalConfig && (
        <ApprovalLineAddModal
          visible={visibleApprovalLineAddModal}
          approvalLines={approvalConfig.approvalLines}
          enterpriseId={enterpriseId}
          onCreate={onCreateApprovalLine}
          onCancel={closeApprovalLineAddModal}
        />
      )}
    </>
  );
}

export default ApprovalConfigContainer;
